<template class="full-height">
  <!-- $t is vue-i18n global function to translate lang -->
  <div class="coupon--datacontainer full-height" style="padding: 10px" v-loading="formLoading">
    <el-card class="box-card">
      <div slot="header" class="clearfix" v-if="travelID">
        <span>旅遊團-優惠票券維護</span>
      </div>
      <div>
        <el-row>
          <el-col :span="12">
            <el-form
              ref="dynamicValidateForm"
              :model="formData"
              :label-width="formLabelWidth"
              label-position="right"
              :disabled="isReadMode"
            >
              <el-form-item
                label="票券名稱"
                prop="couponName"
                :rules="[
                  {
                    required: true,
                    message: '請輸入票券名稱',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input v-model="formData.couponName" placeholder="票券名稱" />
              </el-form-item>

              <el-form-item
                v-if="!agencyCode"
                label="使用位置"
                prop="position"
                :rules="[
                  {
                    required: true,
                    message: '請輸入使用位置',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input v-model="formData.position" placeholder="使用位置" />
              </el-form-item>

              <el-form-item
                v-if="!agencyCode"
                label="連絡電話"
                prop="couponPhone"
                :rules="[
                  {
                    required: true,
                    message: '請輸入連絡電話',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input v-model="formData.couponPhone" placeholder="連絡電話" />
              </el-form-item>

              <el-form-item label="連結網址" prop="link">
                <el-input v-model="formData.link" placeholder="連結網址" />
              </el-form-item>

              <el-form-item label="狀態">
                <el-switch
                  v-model="formData.disabled"
                  active-text="停用"
                  inactive-text="啟用"
                  active-color="#ff4949"
                  inactive-color="#13ce66"
                >
                </el-switch>
              </el-form-item>

              <el-form-item
                label="票券描述"
                prop="description"
                :rules="[
                  {
                    required: true,
                    message: '請輸入票券描述',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  v-model="formData.description"
                  :autosize="{ minRows: 6, maxRows: 8 }"
                  type="textarea"
                  placeholder="票券描述"
                />
              </el-form-item>
              <el-form-item label="開放日期" :label-width="formLabelWidth" prop="dateRange">
                <!-- <el-form-item
                label="開放日期"
                :label-width="formLabelWidth"
                prop="dateRange"
                :rules="[
                  {
                    required: true,
                    message: '請選擇開放日期',
                    trigger: 'change',
                  },
                ]"
              > -->
                <el-date-picker
                  style="width: 100%"
                  @change="dateTrigger"
                  v-model="date"
                  type="daterange"
                  range-separator="至"
                  value-format="yyyy-MM-dd"
                  placeholder="選擇日期"
                />
              </el-form-item>

              <!-- <el-form-item
                label="結束日期"
                :label-width="formLabelWidth"
                prop="endDate"
                :rules="[
                  {
                    required: true,
                    message: '請輸入結束日期',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-date-picker
                  style="width: 100%"
                  v-model="formData.endDate"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="選擇日期"
                />
              </el-form-item> -->
            </el-form>
          </el-col>

          <el-col :span="12">
            <el-form :label-width="formLabelWidth" label-position="right" :disabled="isReadMode">
              <el-form-item label="設定為問卷使用" v-if="agencyCode">
                <el-switch
                  v-model="formData.showToSurvey"
                  active-text="否"
                  inactive-text="是"
                  active-color="#ff4949"
                  inactive-color="#13ce66"
                  :active-value="false"
                  :inactive-value="true"
                >
                </el-switch>
              </el-form-item>

              <el-form-item
                v-show="!formData.showToSurvey"
                label="排序"
                prop="sort"
                :rules="[
                  {
                    required: true,
                    message: '請輸入排序',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input-number v-model="formData.sort" :min="1" label="排序"></el-input-number>
              </el-form-item>

              <el-form-item
                label="票券圖"
                :label-width="formLabelWidth"
                :rules="[
                  {
                    required: true,
                    message: '請上傳票券圖片',
                    trigger: 'blur',
                  },
                ]"
              >
                <div v-if="formData.fileInfo">
                  <Upload
                    ref="uploadRef"
                    :require="true"
                    :limit-file-count="1"
                    :payload="formData"
                    :accept="'.jpg,.jpeg,.png'"
                    :data-obj="fileObj"
                    :use-drag="false"
                    :action="'Coupon/saveCoupon'"
                    :auto-upload="false"
                    :show-file-list="true"
                    :form-on-loading-parent="formLoading"
                    :btn-txt="'上傳'"
                    :before-file-list="
                      formData.fileInfo && formData.fileInfo.length
                        ? formData.fileInfo[0].files
                        : []
                    "
                    :limitText="'APP顯示圖片最佳尺寸為1000x1000大小，圖片須為.jpg,.jpeg,.png格式，限制不超過2000MB'"
                  />
                </div>
              </el-form-item>
              <el-form-item label="票券分類" v-if="!agencyCode">
                <!--<el-alert
                  v-if="!categories || categories.length == 0"
                  title=""
                  type="warning"
                  :closable="false"
                  effect="dark"
                  style="background-color: #ffd643; color: #4b4b4b;cursor: pointer;"
                  @click="openUrl"
                >
                   <template slot="title">
                    <div>
                      <el-button
                        v-loading="listLoading"
                        type="success"
                        icon="el-icon-refresh-left"
                        circle
                        @click="refreshCategories"
                      ></el-button>
                    </div>

                    <div class="iconSize">
                      <el-tag size="mini" type="danger">尚未建立分類</el-tag>
                    </div>
                    <div class="iconSize">
                      <router-link
                        style="cursor: pointer; color: blue"
                        to="/agency/agencyCoupon/couponCategory/index"
                      >
                        請至【活動管理】>【票券管理】>【分類管理】建立分類。(點我連結)</router-link
                      >
                    </div>
                  </template>
                </el-alert>-->

                <el-tag
                  v-if="!categories || categories.length == 0"
                  type="warning"
                  style="height: auto; white-space: break-spaces; font-size: 14px; cursor: pointer"
                  @click="openUrl"
                  >尚未建立分類，請點擊至【活動管理】>【票券管理】>【分類管理】建立分類</el-tag
                >

                <div v-else>
                  <el-button size="mini" type="warning" @click="addCate()">新增</el-button>
                  <br />
                  <div style="height: 300px; border: 1px solid #ccc; padding: 5px">
                    <el-table
                      :data="formData.couponCategories"
                      border
                      size="mini"
                      style="width: 100%"
                      height="100%"
                    >
                      <el-table-column label="層數" width="50">
                        <template slot-scope="scope">
                          {{ scope.$index + 1 }}
                        </template>
                      </el-table-column>
                      <el-table-column label="分類">
                        <template slot-scope="scope">
                          <div class="block">
                            <el-cascader
                              :props="{ checkStrictly: true }"
                              v-model="scope.row.selectedCategories"
                              :disabled="!categories || categories.length == 0"
                              style="width: 100%"
                              placeholder="請選擇"
                              filterable
                              :options="categories"
                            >
                            </el-cascader>
                          </div>
                        </template>
                      </el-table-column>

                      <el-table-column align="center" label="刪除" width="120">
                        <template slot-scope="scope">
                          <el-button size="mini" type="danger" @click="deleteCate(scope.row)"
                            >刪除</el-button
                          >
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
    </el-card>

    <div style="text-align: right; margin-top: 15px">
      <el-button
        v-show="!isReadMode"
        type="warning"
        @click="saveData('dynamicValidateForm')"
        style="color: #4b4b4b"
      >
        儲 存
      </el-button>
      <el-button @click="fatherDialogFormVisible(false)">
        {{ isReadMode ? '關 閉' : '取 消' }}
      </el-button>
    </div>
  </div>
</template>

<script>
import {
  getCoupons,
  getCouponCategoryOptions,
  getCouponLoopCategoryOptions,
  saveCoupon,
} from '@/api/coupon'
import { MessageBox, Message } from 'element-ui'
import Upload from '@/views/ita/components/fileUpload.vue'
import checkPermission from '@/utils/permission' // 权限判断函数

var defaultForm = {
  id: null,
  couponPhone: null,
  couponName: null,
  title: null,
  position: null,
  description: null,
  link: null,
  sort: null,
  couponCategories: [{ sort: 1, selected: null }],
  fileInfo: {},
  beginDate: '',
  endDate: '',
  showToSurvey: false,
  isDefault: false,
  dateRange: [new Date(), new Date()],
}

export default {
  name: 'CouponData',
  components: {
    Upload,
  },
  props: {
    formData: {
      type: Object,
      default: () => defaultForm,
    },
    fatherDialogFormVisible: {
      type: Function,
      default: () => null,
    },
    saveSuccess: {
      type: Function,
      default: () => null,
    },
    travelID: {
      type: Number,
      default: () => null,
    },
    categories: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    formData: {
      handler: function (newVal, oldVal) {
        console.log('trigger form', newVal)
        let vm = this
        vm.date = newVal.dateRange
        newVal.beginDate = newVal.dateRange[0]
        newVal.endDate = newVal.dateRange[1]
        // watch it
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      date: '',
      agencyCode: null,
      formLabelWidth: '120px',
      formLoading: false,
      fileObj: { id: 0, type: 'couponInfo', user: '' },
      categoryOptions: [],
    }
  },
  async activated() {},
  async created() {
    if (this.formData) {
      this.date = this.formData.dateRange
    }
    this.agencyCode = this.$store.getters.userInfo.agencyCode
    this.getCouponCategoryOptions()
  },
  computed: {
    isReadMode: {
      get() {
        return this.formData.id && new Date() > new Date(this.formData.endDate)
      },
    },
  },
  methods: {
    checkPermission,
    async refreshCategories() {
      await this.getCategories()
    },
    dateTrigger() {
      this.formData.dateRange = this.date
    },
    openUrl() {
      this.$router.push('/agency/agencyCoupon/couponCategory/index')
    },
    async getCategories() {
      let vm = this
      this.refreshCategoriesLoading = true
      let resp = await getCouponLoopCategoryOptions({
        agencyCode: vm.agencyCode,
      })
      vm.categories = resp.data
      this.refreshCategoriesLoading = false
    },
    getCouponCategoryOptions() {
      let vm = this
      getCouponCategoryOptions().then(response => {
        vm.categoryOptions = response.data
      })
    },
    addCate() {
      let vm = this
      if (vm.formData.couponCategories.length + 1 > 5) {
        alert('票券分類限制增加五層')
        return
      }
      vm.formData.couponCategories.push({ selected: '' })
    },
    deleteCate(row) {
      let vm = this
      if (vm.formData.couponCategories.length > 0) {
        vm.formData.couponCategories.splice(vm.formData.couponCategories.indexOf(row), 1)
      }
    },
    addData() {
      let vm = this
      vm.formData = defaultForm
    },
    editData(row) {
      let vm = this
      vm.formData = row
    },
    clearFiles() {
      let refUpload = this.$refs['uploadRef']
      if (refUpload) {
        refUpload.clearFiles()
      }
    },
    async saveData(formName) {
      let vm = this
      if (
        !vm.isAdd &&
        !confirm(
          `確定要儲存${vm.formData.couponName ? '【' + vm.formData.couponName + '】' : ''}資料?`
        )
      ) {
        return false
      }

      //旅行社不用分類
      if (vm.formData.couponCategories.length > 0 && !vm.agencyCode) {
        let hasSelectedCategory = true
        vm.formData.couponCategories.forEach((element, index) => {
          element.sort = index + 1
          if (!element.selectedCategories) {
            hasSelectedCategory = false
          }
        })

        if (!hasSelectedCategory) {
          this.$message.error('請刪除未選擇的分類')
          return false
        }

        var valueArr = vm.formData.couponCategories.map(function (item) {
          let r = item.selectedCategories[item.selectedCategories.length - 1]
          return r
        })

        var isDuplicate = valueArr.some(function (item, idx) {
          return valueArr.indexOf(item) != idx
        })

        if (isDuplicate) {
          this.$message.error('請刪除重複的分類')
          return false
        }
      } else {
        vm.formData.couponCategories = []
      }

      let validateWebSet = true

      if (vm.formData.link) {
        let expression =
          /http|https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
        let regex = new RegExp(expression)
        let t = vm.formData.link
        if (!t.match(regex)) {
          vm.$message.error(`連結網址不是有效連結`)
          validateWebSet = false
          return false
        }
      }

      if (!validateWebSet) {
        return
      }

      //$refs["uploadRef"] 不能放在 $refs[formName]的敘述裡面建立，組件裡面會找不到refs.upload
      let refUpload = this.$refs['uploadRef']

      this.$refs[formName].validate(async valid => {
        if (valid) {
          let payload = await refUpload.combineFileAndPayload()
          if (typeof payload === 'boolean' && !payload) {
            return
          }
          if (!payload) {
            alert('檔案繫結表單發生未知錯誤，無法儲存資料。')
            return false
          }
          vm.formLoading = true
          payload.travelID = vm.travelID

          if (!(payload.agencyTravelInfo && payload.agencyTravelInfo.agencyCode) && vm.agencyCode) {
            payload.agencyTravelInfo = {
              agencyCode: vm.agencyCode,
            }
          }
          await saveCoupon(payload)
          vm.clearFiles()
          await vm.saveSuccess()
          vm.fatherDialogFormVisible(false)
          vm.formLoading = false

          Message({
            message: '資料處理完成',
            type: 'success',
            duration: 5 * 1000,
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>

<style>
.full-height {
  position: relative;
  height: 100%;
}
</style>
